const findPathFromEntityId = require("./findPathFromEntityId");

module.exports = function extractLinkData(
	field_data,
	sitemap,
	singleRelationships,
	default_label = "Learn more"
) {
	let to = field_data?.to ? field_data.to : field_data?.uri ? field_data.uri : null;
	if (to) {
		if (to.includes("internal:")) {
			to = to.replace("internal:", "");
		} else if (to.includes("entity:") && sitemap) {
			let nid = to.includes("node/") ? to.split("node/")[1] : null;
			if (nid) {
				let _to = findPathFromEntityId(nid, sitemap);
				if (_to) {
					to = _to;
				}
			}
		}
		let label =
			field_data?.title &&
			typeof field_data.title === "string" &&
			field_data.title.length > 0
				? field_data.title
				: default_label;

		const external = to.includes("http");

		let tokens = singleRelationships ? to.match(/\${(.*?)}/g) : null;
		if (tokens) {
			tokens.forEach((token) => {
				let field_name = token.replace("${", "").replace("}", "");
				if (singleRelationships[field_name] && singleRelationships[field_name].data[0]) {
					let field_value = singleRelationships[field_name].data[0].attributes.title;
					to = to.replace(token, field_value);
					label = label.replace(token, field_value);
				}
			});
		}

		return {
			label,
			to,
			external,
		};
	} else {
		return null;
	}
};
